<template>
  <router-view/>
  <PoweredBy></PoweredBy>
  <notifications position="top right"/>
</template>

<script>
import PoweredBy from '@/components/PoweredBy.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    PoweredBy
  },
  methods: {
    ...mapActions(['loadAppDefinitions', 'setFullApp'])
  },
  computed: {
    ...mapGetters(['getAppDefinitions'])
  },
  async created () {
    window.oncontextmenu = function (event) {
      if (event.button === 2 || event.type === 'touchstart') {
        event.preventDefault()
        event.stopPropagation()
        return false
      }
    }
  }
}
</script>

<style lang="less">
:root {
  --primaryColor: #210946;
  --disabledColor:#cccccc;
  --real-vh: 100%;
}
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  margin: 0;
  padding: 0;
}

html, body, #app {
  height: var(--real-vh);
}

.vue-notification-group {
    margin: 0 !important;
}

.vue-notification-wrapper {
    margin: auto 0 auto auto !important;
}

.vue-notification-template {
    margin: 0 !important;
}

.productview-container + .poweredby-container{
  display: none;
}

</style>
